import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';
import { PRIMARY_COLOR } from './theme';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: PRIMARY_COLOR,
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: {
    pageContainer: {
      paddingInlinePageContainerContent: 20,
      paddingBlockPageContainerContent: 20,
    },
  },
  splitMenus: true,
  menu: {
    autoClose: false,
  },
};
export default Settings;
